import {activeExercisers} from "../constants/exercisers";
import {isNullOrUndefined} from "../services/Validator";

// METHODS
// ---- LOGIC : Check whether given LevelA front-end Exerciser component exists or not
export function doesFrontendExerciserExist(levelAId) {
    const activeExerciser = activeExercisers.find(
        (ex) => ex.id === Number(levelAId)
    );
    return !isNullOrUndefined(activeExerciser)
}

